import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Companies List
export const companiesList = createAsyncThunk(
  "companiesList",
  async (
    { search, status, sort_by, pageLimit, sort_direction, pageCount, contract },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `companies?search=${search}&sort_by=${sort_by}&sort_direction=${sort_direction}&status=${status}&page=${pageCount}&limit=${pageLimit}&contract=${contract}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Companies List bt id
export const getCompanies = createAsyncThunk(
  "getCompanies",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`companies/${id}`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Create Company
export const createCompany = createAsyncThunk(
  "createCompany",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`companies`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// update Company
export const updateCompany = createAsyncThunk(
  "updateCompany",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`companies/${id}`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Delete Director / Shareholder
export const DeleteCompany = createAsyncThunk(
  "DeleteCompany",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`companies/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Outlet List
export const getOutlet = createAsyncThunk(
  "getOutlet",
  async (
    { pageCount ,pageLimit, search, company_id, sort_by, sort_direction },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `outlets?limit=${pageLimit}&search=${search}&page=${pageCount}&sort_by=${sort_by}&sort_direction=${sort_direction}&company_id=${company_id}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Create Outlet
export const createOutlet = createAsyncThunk(
  "createOutlet",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`outlets`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Create Outlet
export const createEquipment = createAsyncThunk(
  "createEquipment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`company-equipment`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Equipment List
export const getEquipment = createAsyncThunk(
  "getEquipment",
  async (
    {
      search,
      sort_by,
      pageLimit,
      sort_direction,
      pageCount,
      equipment,
      outlet,
      company_id,
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `company-equipment-list?search=${search}&sort_by=${sort_by}&sort_direction=${sort_direction}&page=${pageCount}&limit=${pageLimit}&equipment=${equipment}&outlet=${outlet}&company_id=${company_id}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// getAllTechnicianList
export const getAllTechnicianList = createAsyncThunk(
  "getAllTechnicianList",
  async ({ limit, search }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(
        `technicians?limit=${limit}&search=${search}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Create Technician
export const createTechnician = createAsyncThunk(
  "createTechnician",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`company-technicians`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// getSalesPersonList
export const getSalesPersonList = createAsyncThunk(
  "getSalesPersonList",
  async ({ limit, search }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(
        `sales-person-list?limit=${limit}&search=${search}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Create Technician
export const createSalesPerson = createAsyncThunk(
  "createSalesPerson",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`company-sales-person`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Create Remark
export const createRemark = createAsyncThunk(
  "createRemark",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`company-remark`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Delete Remark
export const DeleteRemark = createAsyncThunk(
  "DeleteRemark",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`company-remark/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Delete technicians
export const DeleteTechnicians = createAsyncThunk(
  "DeleteTechnicians",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`company-technicians/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Delete Remark
export const DeleteSales = createAsyncThunk(
  "DeleteSales",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`company-sales-person/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Create staff
export const createStaff = createAsyncThunk(
  "createStaff",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`company-staff-person`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Create Doc
export const createDocument = createAsyncThunk(
  "createDocument",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`company-documents/download`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// companiesStaff
export const companiesStaff = createAsyncThunk(
  "companiesStaff",
  async (
    {
      roles,
      types,
      outlet,
      search,
      pageLimit,
      pageCount,
      company_id,
      sort_by,
      sort_direction,
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `company-staff?roles=${roles}&sort_by=${sort_by}&sort_direction=${sort_direction}&types=${types}&outlet=${outlet}&search=${search}&page=${pageCount}&limit=${pageLimit}&company_id=${company_id}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Create Transfer
export const createTransfer = createAsyncThunk(
  "createTransfer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`company-transfer-equipment`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Create Transfer staff
export const createStaffTransfer = createAsyncThunk(
  "createTransfer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`company-transfer-staff`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Delete Transfer
export const DeleteTransfer = createAsyncThunk(
  "DeleteTransfer",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`company-equipment/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Delete Outlet
export const DeleteOutlet = createAsyncThunk(
  "DeleteOutlet",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`outlets/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Delete Staff
export const DeleteStaff = createAsyncThunk(
  "DeleteStaff",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`company-staff/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// update Staff
export const updateStaff = createAsyncThunk(
  "updateStaff",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`company-staff/${id}`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

export const getDocumnetList = createAsyncThunk(
  "getDocumnetList",
  async (
    {
      pageLimit,
      search,
      type,
      date_range,
      company_id,
      pageCount,
      sort_by,
      sort_direction,
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `company-documents?limit=${pageLimit}&search=${search}&type=${type}&date_range=${date_range}&company_id=${company_id}&pageCount=${pageCount}&sort_by=${sort_by}&sort_direction=${sort_direction}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const companiesSlice = createSlice({
  name: "companies",
  initialState: initialStates,
  extraReducers: {
    // companies
    [companiesList.pending]: (state) => {
      state.loading = true;
    },
    [companiesList.fulfilled]: (state, action) => {
      state.loading = false;
      state.companiesListStatus.data = action.payload;
      state.error = false;
    },
    [companiesList.rejected]: (state) => {
      state.loading = false;
      state.error = true;
    },
    // get companies
    [getCompanies.pending]: (state) => {
      state.loading = true;
    },
    [getCompanies.fulfilled]: (state, action) => {
      state.loading = false;
      state.getCompaniesStatus.data = action.payload;
      state.error = false;
    },
    [getCompanies.rejected]: (state) => {
      state.loading = false;
      state.error = true;
    },
    // Create Company
    [createCompany.pending]: (state) => {
      state.loading = true;
    },
    [createCompany.fulfilled]: (state, action) => {
      state.loading = false;
      state.createCompanyStatus.data = action.payload;
      state.error = false;
    },
    [createCompany.rejected]: (state) => {
      state.loading = false;
      state.error = true;
    },
    // update Company
    [updateCompany.pending]: (state) => {
      state.loading = true;
    },
    [updateCompany.fulfilled]: (state, action) => {
      state.loading = false;
      state.updateCompanyStatus.data = action.payload;
      state.error = false;
    },
    [updateCompany.rejected]: (state) => {
      state.loading = false;
      state.error = true;
    },

    // Delete Director Shareholder
    [DeleteCompany.pending]: (state) => {
      state.loading = true;
    },
    [DeleteCompany.fulfilled]: (state, action) => {
      state.loading = false;
      state.deleteDirectorShareholderStatus.data = action.payload;
      state.error = false;
    },
    [DeleteCompany.rejected]: (state) => {
      state.loading = false;
      state.error = true;
    },

    // getOutlet
    [getOutlet.pending]: (state) => {
      state.loading = true;
    },
    [getOutlet.fulfilled]: (state, action) => {
      state.loading = false;
      state.getOutletStatus.data = action.payload;
      state.error = false;
    },
    [getOutlet.rejected]: (state) => {
      state.loading = false;
      state.error = true;
    },
    // Create Company
    [createOutlet.pending]: (state) => {
      state.loading = true;
    },
    [createOutlet.fulfilled]: (state, action) => {
      state.loading = false;
      state.createOutletStatus.data = action.payload;
      state.error = false;
    },
    [createOutlet.rejected]: (state) => {
      state.loading = false;
      state.error = true;
    },
    // getEquipment
    [getEquipment.pending]: (state) => {
      state.loading = true;
    },
    [getEquipment.fulfilled]: (state, action) => {
      state.loading = false;
      state.getEquipmentStatus.data = action.payload;
      state.error = false;
    },
    [getEquipment.rejected]: (state) => {
      state.loading = false;
      state.error = true;
    },
    // getAllTechnicianList
    [getAllTechnicianList.pending]: (state) => {
      state.loading = true;
    },
    [getAllTechnicianList.fulfilled]: (state, action) => {
      state.loading = false;
      state.getAllTechnicianListStatus.data = action.payload;
      state.error = false;
    },
    [getAllTechnicianList.rejected]: (state) => {
      state.loading = false;
      state.error = true;
    },
    // getSalesPersonList
    [getSalesPersonList.pending]: (state) => {
      state.loading = true;
    },
    [getSalesPersonList.fulfilled]: (state, action) => {
      state.loading = false;
      state.getSalesPersonListStatus.data = action.payload;
      state.error = false;
    },
    [getSalesPersonList.rejected]: (state) => {
      state.loading = false;
      state.error = true;
    },

    // get documnet
    [getDocumnetList.pending]: (state) => {
      state.loading = true;
    },
    [getDocumnetList.fulfilled]: (state, action) => {
      state.loading = false;
      state.getDocumnetListStatus.data = action.payload;
      state.error = false;
    },
    [getDocumnetList.rejected]: (state) => {
      state.loading = false;
      state.error = true;
    },
    // companies
    [companiesStaff.pending]: (state) => {
      state.loading = true;
    },
    [companiesStaff.fulfilled]: (state, action) => {
      state.loading = false;
      state.companiesStaffStatus.data = action.payload;
      state.error = false;
    },
    [companiesStaff.rejected]: (state) => {
      state.loading = false;
      state.error = true;
    },
  },
});
const { reducer } = companiesSlice;
export default reducer;
